<template>
    <h1>Это домашнаяя старинца ученика</h1>
    <p>Страница находится в разработке, но вы можете ознакомиться с другими модулями сервиса, нажав на соответствующие кнопки в боковом (нижнем) меню</p>
</template>

<script lang="ts" setup>

</script>

<style lang="sccs" scoped>

</style>